module.exports = __webpack_public_path__ + "assets/naviserver.d71c0728.svg";